import React, { useState, useEffect } from 'react';
import { 
  Dialog, 
  DialogContent,
  Autocomplete,
  TextField,
  CircularProgress,
  ListItem,
  ListItemText,
  Typography,
  Button,
  Collapse,
  Chip,
  Box,
  Divider,
  Switch,
  FormControlLabel
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CloseIcon from '@mui/icons-material/Close';
import EventIcon from '@mui/icons-material/Event';

import SeleccionarTratamiento from './SeleccionarTratamiento';
import './NuevaCita.css';
import NuevoCliente from './NuevoCliente';

const NuevaCita = ({ open, onClose, citaData, onCitaCreada, id_salon }) => {

  const apiUrl = process.env.REACT_APP_API_URL;

  const [openNuevoCliente, setOpenNuevoCliente] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [showTratamientos, setShowTratamientos] = useState(false);
  const [tratamientosSeleccionados, setTratamientosSeleccionados] = useState([]);

  // NUEVO ESTADO PARA CITA WEB
  const [esCitaWeb, setEsCitaWeb] = useState(false);

  const formatFecha = () => {
    if (!citaData?.fecha) return '';

    const date = new Date(citaData.fecha + 'T12:00:00');

    const options = {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    };

    return date.toLocaleDateString('es-ES', options);
  };

  const prepararDatosCita = () => {

    if (!selectedCliente || !citaData) return null;

    const fechaLocal = new Date(`${citaData.fecha}T${citaData.hora}:00`);

    const fechaUTC = new Date(
      fechaLocal.getTime() -
      (fechaLocal.getTimezoneOffset() * 60000)
    );

    const fechaHoraISO = fechaUTC
      .toISOString()
      .slice(0, 16)
      .replace('T', ' ');

    const datosCita = {
      fecha_hora: fechaHoraISO,

      id_cliente: selectedCliente.id_cliente,

      // CAMBIO AQUÍ
      id_empleado: esCitaWeb ? 4 : 3,

      id_puesto: citaData.id_puesto,

      id_salon: citaData.id_salon,

      tratamientos: tratamientosSeleccionados.map(t => ({
        id_tratamiento: t.id_tratamiento,
        duracion: t.duracion_tratamiento,
        precio: t.precio_tratamiento
      }))
    };

    console.log("Esto se envía para la cita nueva:", datosCita);

    return datosCita;
  };

  const guardarCita = async (datosCita) => {

    try {

      const response = await fetch(`${apiUrl}/api/citanueva`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosCita)
      });

      if (!response.ok) {
        throw new Error('Error al guardar la cita');
      }

      const data = await response.json();

      return data;

    } catch (error) {

      console.error('Error:', error);
      throw error;
    }
  };

  const handleSubmit = async () => {

    const datosCita = prepararDatosCita();

    if (datosCita) {

      try {

        const resultado = await guardarCita(datosCita);

        console.log('Cita creada:', resultado);

        onClose();

        if (onCitaCreada) {
          onCitaCreada();
        }

      } catch (error) {

        alert('Error al crear la cita: ' + error.message);
      }
    }
  };

  // BUSCAR CLIENTES
  useEffect(() => {

    const searchClientes = async () => {

      if (searchTerm.length < 3) {
        setClientes([]);
        return;
      }

      setLoading(true);

      try {

        const response = await fetch(
          `${apiUrl}/api/clientes/search2?search=${encodeURIComponent(searchTerm)}`
        );

        const data = await response.json();

        setClientes(data);

      } catch (error) {

        console.error('Error buscando clientes:', error);

      } finally {

        setLoading(false);
      }
    };

    const timer = setTimeout(() => searchClientes(), 300);

    return () => clearTimeout(timer);

  }, [searchTerm]);

  const handleClienteSelect = (event, newValue) => {
    setSelectedCliente(newValue);
  };

  const toggleTratamientos = () => {
    setShowTratamientos(!showTratamientos);
  };

  const handleTratamientosChange = (nuevosTratamientos) => {
    setTratamientosSeleccionados(nuevosTratamientos);
  };

  const quitarTratamiento = (id) => {

    setTratamientosSeleccionados(prev =>
      prev.filter(t => t.id_tratamiento !== id)
    );
  };

  const calcularTotal = () => {

    return tratamientosSeleccionados
      .reduce(
        (sum, t) => sum + parseFloat(t.precio_tratamiento),
        0
      )
      .toFixed(2);
  };

  return (

    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className="nueva-cita-dialog"
    >

      <div className="nueva-cita-header">

        <div className="d-flex justify-content-between align-items-center">
        </div>

        <div className="d-flex align-items-center mt-3">

          <span className="nueva-cita-fecha">
            Nueva cita para el {formatFecha()} a las {citaData?.hora || ''}
          </span>

          <button
            onClick={onClose}
            className="nueva-cita-close-btn"
          >
            <CloseIcon />
          </button>

        </div>

      </div>

      <DialogContent className="nueva-cita-content">

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >

          <Autocomplete
            freeSolo
            options={clientes}
            value={selectedCliente}
            getOptionLabel={(option) =>
              typeof option === 'string'
                ? option
                : `${option.nombre} ${option.apellido}`
            }
            loading={loading}
            onChange={handleClienteSelect}
            onInputChange={(event, newInputValue) => {
              setSearchTerm(newInputValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Buscar cliente"
                variant="outlined"
                fullWidth
                className="nueva-cita-input"
                InputProps={{
                  ...params.InputProps,

                  startAdornment: (
                    <SearchIcon sx={{ color: 'gray', mr: 1 }} />
                  ),

                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}

                      {params.InputProps.endAdornment}
                    </>
                  ),

                  sx: {
                    borderRadius: 2,
                    backgroundColor: '#f5f5f5',

                    '&:hover': {
                      backgroundColor: '#e0e0e0'
                    },

                    '&.Mui-focused': {
                      backgroundColor: 'white',
                      borderColor: '#3f51b5'
                    }
                  }
                }}
              />
            )}
            sx={{
              flexGrow: 1,
              minWidth: 300
            }}
          />

          <Button
            variant="contained"
            onClick={() => setOpenNuevoCliente(true)}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Nuevo Cliente
          </Button>

          {/* NUEVO SWITCH */}
          <FormControlLabel
            control={
              <Switch
                checked={esCitaWeb}
                onChange={(e) => setEsCitaWeb(e.target.checked)}
                color="primary"
              />
            }
            label="Cita Web"
            sx={{ ml: 1 }}
          />

        </Box>

        {/* BOTÓN TRATAMIENTOS */}

        <Button
          fullWidth
          variant="outlined"
          startIcon={<AddIcon />}
          endIcon={
            showTratamientos
              ? <ExpandLessIcon />
              : <ExpandMoreIcon />
          }
          onClick={toggleTratamientos}
          sx={{
            mt: 3,
            py: 1.5,
            justifyContent: 'space-between',
            backgroundColor: showTratamientos
              ? '#f5f5f5'
              : 'inherit',

            '&:hover': {
              backgroundColor: '#f0f0f0'
            }
          }}
        >
          Añadir Tratamientos
        </Button>

        <Collapse in={showTratamientos} sx={{ mb: 2 }}>

          <SeleccionarTratamiento
            onSeleccion={(tratamiento) => {
              setTratamientosSeleccionados(prev => [
                ...prev,
                tratamiento
              ]);
            }}

            seleccionadoInicial={null}

            onTratamientoSeleccionado={() =>
              setShowTratamientos(false)
            }
          />

        </Collapse>

        {/* TRATAMIENTOS */}

        {tratamientosSeleccionados.length > 0 && (

          <Box sx={{ mt: 2 }}>

            <Typography variant="subtitle2">
              Tratamientos seleccionados:
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                mt: 1
              }}
            >

              {tratamientosSeleccionados.map((tratamiento) => (

                <Chip
                  key={tratamiento.id_tratamiento}
                  label={`${tratamiento.nombre_tratamiento} (${tratamiento.precio_tratamiento}€)`}
                  onDelete={() =>
                    quitarTratamiento(tratamiento.id_tratamiento)
                  }
                />

              ))}

            </Box>

            <Typography
              variant="body1"
              sx={{
                mt: 1,
                fontWeight: 'bold'
              }}
            >
              Total: €{calcularTotal()}
            </Typography>

            <Divider sx={{ my: 2 }} />

          </Box>

        )}

        {/* BOTONES */}

        <div className="d-flex justify-content-end gap-3 mt-4">

          <button
            onClick={onClose}
            className="nueva-cita-cancel-btn"
          >
            Cancelar
          </button>

          <button
            onClick={handleSubmit}
            className="nueva-cita-confirm-btn"
            disabled={
              !selectedCliente ||
              tratamientosSeleccionados.length === 0
            }
          >
            Confirmar
          </button>

        </div>

        {/* NUEVO CLIENTE */}

        <NuevoCliente
          open={openNuevoCliente}

          onClose={() => setOpenNuevoCliente(false)}

          onClienteCreado={(nuevoCliente) => {

            setClientes(prev => [
              ...prev,
              nuevoCliente
            ]);

            setSelectedCliente(nuevoCliente);

            setSearchTerm('');
          }}
        />

      </DialogContent>

    </Dialog>
  );
};

export default NuevaCita;